import { QueryType } from './query.model';

export const FILTER_QUERY_FAVOURITE = 'IsFavourite';
export const FILTER_HANDLER_FAVOURITE = 'isFavourite';
export const FILTER_HANDLER_SEARCH = 'search';
export const FILTER_QUERY_SEARCH = 'Search';
export const FILTER_QUERY_SEARCH_CLEAR = 'SearchClear';
export const FILTER_SARCH_BAR_CONFIG = 'Identity';
export const FILTER_QUERY_BATCH = 'BatchId';

export enum ActivitySelectType {
    OpenInbox = 'OpenInbox',
    CompletedInbox = 'CompletedInbox',
}

export type SelectType = QueryType | ActivitySelectType;
